module.exports = __webpack_public_path__ + "r-v3/img/ico_download_white.f5eba1dc.svg";